<template>
  <MTooltip placement="top">
    <template v-slot:trigger>
      <a href="javascript:;" v-on="$listeners">
        <MIcon name="two-column" />
      </a>
    </template>
    {{ $t('collapse') }}
  </MTooltip>
</template>

<script>
export default {
  name: 'ControlCollapseButton',
}
</script>
